const KL_RELATED_PRODUCTS_SELECTOR = '[data-kl-related-products]';
const KL_RELATED_PRODUCTS_PLACEHOLDER_SELECTOR = '[data-kl-related-products-placeholder]';
const KL_RELATED_PRODUCTS_CONTENT_EVENT = 'kl:content:added';
const KL_RELATED_PRODUCTS_WISHLIST_SYNC_EVENT = 'kl:wishlist:sync';
const KL_RELATED_PRODUCTS_UNAVAILABLE_CLASS = 'is-unavailable';

const KL_RELATED_PRODUCTS_NEAR_MARGIN = '0px 0px 400px 0px';

const KL_RELATED_PRODUCTS_DEADLINE = 15000;

function initRelatedProducts(root) {
  if (root.dataset.klRelatedProductsReady === 'true') return;

  root.dataset.klRelatedProductsReady = 'true';

  if (!root.querySelector(KL_RELATED_PRODUCTS_PLACEHOLDER_SELECTOR)) return;

  let deadlineTimer = null;

  const arrivalObserver = new MutationObserver(() => {
    arrivalObserver.disconnect();
    window.clearTimeout(deadlineTimer);

    try {
      document.dispatchEvent(
        new CustomEvent(KL_RELATED_PRODUCTS_CONTENT_EVENT, { detail: { root } })
      );
      document.dispatchEvent(new CustomEvent(KL_RELATED_PRODUCTS_WISHLIST_SYNC_EVENT));
    } catch (error) {
      console.debug('kl-related-products: the row arrived but could not be woken up', { error });
    }
  });

  arrivalObserver.observe(root, { childList: true });

  const nearViewportObserver = new IntersectionObserver(
    (entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;

      nearViewportObserver.disconnect();

      deadlineTimer = window.setTimeout(() => {
        arrivalObserver.disconnect();
        root.classList.add(KL_RELATED_PRODUCTS_UNAVAILABLE_CLASS);

        console.debug('kl-related-products: no products came back, so the placeholder was taken away', {
          sectionId: root.dataset.sectionId,
          productId: root.dataset.productId,
        });
      }, KL_RELATED_PRODUCTS_DEADLINE);
    },
    { rootMargin: KL_RELATED_PRODUCTS_NEAR_MARGIN }
  );

  nearViewportObserver.observe(root);
}

function initRelatedProductsRows(rootElement) {
  rootElement.querySelectorAll(KL_RELATED_PRODUCTS_SELECTOR).forEach(initRelatedProducts);
}

initRelatedProductsRows(document);

document.addEventListener('shopify:section:load', (event) => {
  initRelatedProductsRows(event.target);
});
